jQuery(document).ready(function($) {
    $('#load-more').on('click', function(e) {
        e.preventDefault();

        var button = $(this);
        var page = parseInt(button.attr('data-page'));
        var maxPages = parseInt(button.attr('data-max-pages'));

        button.prop('disabled', true).text('Loading...');

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'load_more_posts',
                page: page
            },
            success: function(response) {
                if (response.success) {
                    $('#blog-posts').append(response.data.html);
                    page++;
                    button.attr('data-page', page);

                    if (page >= maxPages) {
                        button.hide();
                    } else {
                        button.prop('disabled', false).html('Load More Articles <i class="icon icon-arrow"></i>');
                    }
                } else {
                    button.hide();
                }
            },
            error: function() {
                button.prop('disabled', false).html('Load More Articles <i class="icon icon-arrow"></i>');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');

    let tabFocus = 0;

    // Keyboard navigation (Left/Right)
    tabList.addEventListener('keydown', e => {
        const keyLeft = 37;
        const keyRight = 39;

        if (e.keyCode === keyLeft || e.keyCode === keyRight) {
            tabs[tabFocus].setAttribute("tabindex", "-1");

            if (e.keyCode === keyRight) {
                tabFocus++;
                if (tabFocus >= tabs.length) tabFocus = 0;
            } else if (e.keyCode === keyLeft) {
                tabFocus--;
                if (tabFocus < 0) tabFocus = tabs.length - 1;
            }

            tabs[tabFocus].setAttribute("tabindex", "0");
            tabs[tabFocus].focus();
        }
    });
});